// extracted by mini-css-extract-plugin
module.exports = {"shopSelector":"ShopPicker_shopSelector__3fzRm"};